import LoginView from "./login-view";
import {events}  from "../../commun/backbone/decorators";


@events({
            'click #sso-openidconnect' : '_onClickSSOOpenIdConnect',
            'input #login-username' : '_onInputUsername',
        })
class LoginPageView extends LoginView
{

    initialize(options)
    {
        super.initialize(options);

        //-- hack pour le 100vh sur mobile
        const documentHeight = () => {
            const doc = document.documentElement
            doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
        }
        window.addEventListener('resize', documentHeight);
        documentHeight();
    }

    render()
    {
        this.$ssoopenidconnect = $('#sso-openidconnect');
        this.$btnconfigure = $('#btn-configure');
        return super.render();
    }


    _onInputUsername(event)
    {
        if (!this.model.get('with_configuration')){
            return ;
        }
        const that = this;
        clearTimeout(this.timeoutid);
        this.timeoutid = setTimeout(function (){
            that.$username.addClass('is-loading');
            that.model.fGetUserInfo(that.$username.val())
                .then(function (data)
                      {
                          if (data.with_configuration)
                          {
                              that.$btnconnexion.removeClass('without-config');
                              that.$btnconfigure.removeClass('d-none');
                          }
                          else {
                              that.$btnconnexion.addClass('without-config');
                              that.$btnconfigure.addClass('d-none');
                          }

                          //gestion de la locale
                          that.model.loadUserLanguage(data.language_code);
                      })
                .catch(function(jqx){
                    that.$btnconnexion.addClass('without-config');
                    that.$btnconfigure.addClass('d-none');
                })
                .finally(function (){
                    that.$username.removeClass('is-loading');
                });
        }, 400);
    }

    _onClickSSOOpenIdConnect(event)
    {
        event.preventDefault();

        let params = {
            'm_sLocale': this.$locale.val(),
        };

        if (this.$timezone.length){
            params['m_sTimeZone']=this.$timezone.val();
        }

        const paramsEncoded = $.param( params );
        window.location = this.$ssoopenidconnect.attr('data-url')+'?' + paramsEncoded;
    }
}
export default LoginPageView;